import React, { useContext, useState, useEffect /*, useLayoutEffect*/ } from 'react';
import { useStaticQuery, graphql, Script } from 'gatsby';
import Helmet from 'react-helmet';
import loadable from '@loadable/component';
import Footer from '../../components/Footer';
import LazyLoader from '../../components/LazyLoader';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Elements } from '@stripe/react-stripe-js';
// import OneSignal from 'react-onesignal';
// import Countdown from "react-countdown";
import { navigate } from '@reach/router';
import { window } from 'browser-monads';
import { Trans, Link, useI18next } from 'gatsby-plugin-react-i18next';
import GB from 'country-flag-icons/react/3x2/GB';
import DE from 'country-flag-icons/react/3x2/DE';
import FR from 'country-flag-icons/react/3x2/FR';
import ES from 'country-flag-icons/react/3x2/ES';
import PT from 'country-flag-icons/react/3x2/PT';
import IT from 'country-flag-icons/react/3x2/IT';
import NL from 'country-flag-icons/react/3x2/NL';
import AE from 'country-flag-icons/react/3x2/AE';
import JP from 'country-flag-icons/react/3x2/JP';

import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import HoverMenu from 'material-ui-popup-state/HoverMenu';
import { usePopupState, bindHover, bindMenu } from 'material-ui-popup-state/hooks';

import ShopifyContext, { ShopifyProvider } from '../../context/ShopifyContext';
import logo from '../../images/logo.png';

// const Footer = loadable(() => import('../../components/Footer'));
const Cart = loadable(() => import('../../components/Cart'));

const getCount = ({ lineItems = [] }: any) => {
  let count = 0;
  lineItems.forEach(({ quantity }: any) => {
    count = count + parseFloat(quantity);
  });

  return count;
};

const languageSelect = (language: string, showLngTxt: Boolean) => {
  const languageFlag = (lang: string) => {
    switch (lang) {
      case 'en':
        return <GB style={{ width: '16px', height: '20px' }} />;
        break;
      case 'de':
        return <DE style={{ width: '16px', height: '20px' }} />;
        break;
      case 'fr':
        return <FR style={{ width: '16px', height: '20px' }} />;
        break;
      case 'es':
        return <ES style={{ width: '16px', height: '20px' }} />;
        break;
      case 'pt':
        return <PT style={{ width: '16px', height: '20px' }} />;
        break;
      case 'it':
        return <IT style={{ width: '16px', height: '20px' }} />;
        break;
      case 'nl':
        return <NL style={{ width: '16px', height: '20px' }} />;
        break;
      case 'ar':
        return <AE style={{ width: '16px', height: '20px' }} />;
        break;
      case 'ja':
        return <JP style={{ width: '16px', height: '20px' }} />;
        break;
      default:
        return <GB style={{ width: '16px', height: '20px' }} />;
        break;
    }
  };
  const languageTxt = (lang: string, showLngTxt: Boolean) => {
    if (!showLngTxt) {
      return null;
    }
    switch (lang) {
      case 'en':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            English
          </Typography>
        );
        break;
      case 'de':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            Deutsch
          </Typography>
        );
        break;
      case 'fr':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            Français
          </Typography>
        );
        break;
      case 'es':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            Español
          </Typography>
        );
        break;
      case 'pt':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            Português
          </Typography>
        );
        break;
      case 'it':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            Italiano
          </Typography>
        );
        break;
      case 'nl':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            Nederlands
          </Typography>
        );
        break;
      case 'ar':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            عربي
          </Typography>
        );
        break;
      case 'ja':
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            日本語
          </Typography>
        );
        break;
      default:
        return (
          <Typography variant="body1" sx={{ color: 'black', pl: 0.5, textDecoration: 'lowercase' }}>
            English
          </Typography>
        );
        break;
    }
  };

  return (
    <Box className="language" sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
      {languageFlag(language)}
      {languageTxt(language, showLngTxt)}
    </Box>
  );
};

const PageLayout: React.FunctionComponent = ({ children }) => {
  const { checkout = {} } = useContext(ShopifyContext);
  const [open, setOpen] = useState(false);
  const [stripeLoaded, setStripeLoaded] = useState(false);
  const [stripeObject, setStripeObject] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [count, setCount] = useState(getCount(checkout));
  const [showLngTxt, setShowLngTxt] = useState(window.innerWidth > 500 ? true : false);
  const [searchtext, setSearchtext] = useState('');
  const { language, languages, changeLanguage, originalPath } = useI18next();

  const lngPopupState = usePopupState({
    variant: 'popover',
    popupId: `language`,
  });
  // const runOneSignal = async () => {
  //   await OneSignal.init({ appId: '2a1dd530-0731-4a29-aeb1-570eddcfcba3', allowLocalhostAsSecureOrigin: true});
  //   OneSignal.showSlidedownPrompt();
  // }

  const {
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          navigation {
            menu {
              type
              displayName
              link
              subMenu {
                displayName
                link
              }
            }
          }
        }
      }
    }
  `);

  useEffect(() => {
    setCount(getCount(checkout));
  }, [checkout]);

  useEffect(() => {
    window.addEventListener('resize', (e) => {
      if (window.innerWidth > 600) {
        setShowLngTxt(true);
      } else {
        setShowLngTxt(false);
      }
    });
  }, [window.innerWidth]);

  useEffect(() => {
    if (open && !stripeLoaded) {
      setStripeLoaded(true);
    }
  }, [open]);

  useEffect(() => {
    const fetchStripeObject = async () => {
      // If there is no accountId, do not run the loadStripe function.
      if (stripeLoaded && !stripeObject) {
        const res = await loadStripe(
          'pk_live_51GtwKiJYwiQvGDcVOTV7PpDTezJh1WQYbdpLmKooduIRi6E3nKac4Tx8BLTqhnNKJK5kvdFbLkWpTOjZIMl1HEGX00unyIPaUI'
        );
        // When we have got the Stripe object, pass it into our useState.
        setStripeObject(res);
      }
    };
    fetchStripeObject();
  }, [stripeLoaded]);

  return (
    <Box className="layout">
      {/*<Helmet>
        <link rel="preconnect" href="https://cdn.shopify.com" />
        <link rel="dns-prefetch" href="https://cdn.shopify.com" />
      </Helmet>*/}
      <Script
        strategy="idle"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NF3BFL3');`,
        }}
      />
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NF3BFL3" title="google tag manager"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      {/*Anouncement Messages*/}
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
        spacing={0}
        sx={{ position: 'fixed', top: 0, zIndex: '1000', width: '100vw', minHeight: '34px', bgcolor: '#000000ee' }}>
        <Typography variant="body2" sx={{ fontSize: '12px', color: '#fffffff3', lineHeight: '34px', height: '34px', textAlign: 'center' }}>
          We only support buyer from paganidesignwatch.com & paganidesignwatch.net
        </Typography>
      </Stack>
      {/*Navigation*/}
      <AppBar position="fixed" elevation={0} color="inherit" enableColorOnDark sx={{ width: '100vw', top: '34px', left: '0' }}>
        <Toolbar sx={{ m: 0, p: 0, width: '100vw' }}>
          <Grid container spacing={0} columns={12} sx={{ width: '100vw' }}>
            {/*menu*/}
            <Grid
              item
              xs={1}
              sm={1}
              md={4}
              lg={5}
              sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly' }}>
              <IconButton
                id="openMenu"
                className="openMenu"
                aria-label="open menu"
                sx={{
                  m: 0,
                  p: 0,
                  height: '100%',
                  lineHeight: '100%',
                  borderRadius: 0,
                  '&:hover': {
                    bgcolor: '#ffffff',
                  },
                  display: { sm: 'block', md: 'none' },
                  ...(menuOpen && { display: 'none' }),
                }}
                onClick={() => {
                  setMenuOpen(true);
                }}>
                <MenuIcon color="action" fontSize="medium" />
              </IconButton>

              {siteMetadata.navigation.menu.map(({ type, displayName, subMenu }, index) => {
                if (type == 'Menu') {
                  const popupState = usePopupState({
                    variant: 'popover',
                    popupId: `${displayName}`,
                  });
                  return (
                    <Box key={index} sx={{ mr: '2rem', py: 0, m: 0, display: { xs: 'none', md: 'flex' } }}>
                      <Button color="inherit" variant="text" sx={{ fontSize: '16px', fontWeight: '700' }} {...bindHover(popupState)}>
                        <Trans>{displayName}</Trans>
                      </Button>
                      <HoverMenu
                        {...bindMenu(popupState)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                        {subMenu.map(({ displayName, link }, menuindex) => {
                          return (
                            <MenuItem
                              key={`${index}-${menuindex}`}
                              onClick={(event) => {
                                event.preventDefault();
                                popupState.close;
                                // navigate(link);
                              }}>
                              <Link
                                to={link}
                                language={language}
                                id="navMenu"
                                className="navMenu"
                                style={{ textDecoration: 'none', fontSize: '15px' }}>
                                <Trans>{displayName}</Trans>
                              </Link>
                            </MenuItem>
                          );
                        })}
                      </HoverMenu>
                    </Box>
                  );
                }
              })}
            </Grid>
            {/*logo*/}
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <Box sx={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <Link to={'/'} language={language} id="navLogo" className="navLogo">
                  <Avatar
                    alt="Logo"
                    src={logo}
                    variant="square"
                    sx={{
                      width: 'auto',
                      height: { xs: '20px', sm: '25px', md: '30px', lg: '35px' },
                    }}
                  />
                </Link>
              </Box>
            </Grid>
            {/*search*/}
            <Grid item xs={7} sm={7} md={4} lg={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <Paper
                  component="form"
                  elevation={0}
                  sx={{
                    m: '4px 4px',
                    display: 'flex',
                    alignItems: 'center',
                    alingContent: 'center',
                    // width: { xs: 160, sm: 200, md: 240, lg: 260, xl: 300 },
                    height: 27,
                    border: 'solid 1px #e0e0e0',
                    borderRadius: '6px',
                  }}>
                  <InputBase
                    id="searchContent"
                    className="searchContent"
                    placeholder="Search"
                    value={`${searchtext}`}
                    onChange={(event) => {
                      setSearchtext(event.target.value);
                    }}
                    sx={{ mx: 1, flex: 1 }}
                  />
                  <IconButton
                    type="submit"
                    size="small"
                    aria-label="search"
                    sx={{
                      p: '1px',
                      '&:hover': {
                        bgcolor: '#ffffff',
                      },
                    }}
                    onClick={(event) => {
                      event.preventDefault();
                      if (searchtext != '') {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                          event: 'search',
                          search: {
                            search_term: `${searchtext}`,
                          },
                        });
                      }
                    }}>
                    <Link
                      to={`/search?q=${searchtext}`}
                      language={language}
                      id="search"
                      className="search"
                      style={{ textDecoration: 'none' }}>
                      <SearchIcon fontSize="medium" />
                    </Link>
                  </IconButton>
                </Paper>
                <IconButton
                  id="openCart"
                  className="openCart"
                  aria-label="open cart"
                  sx={{
                    m: 0,
                    p: 0,
                    mx: '5px',
                    '&:hover': {
                      bgcolor: '#ffffff',
                    },
                  }}
                  onClick={() => {
                    setOpen(true);
                  }}>
                  <Badge badgeContent={count} color="primary" size="large" showZero>
                    <ShoppingCartOutlinedIcon color="action" fontSize="medium" />
                  </Badge>
                </IconButton>
              </Box>
            </Grid>
            {/*language*/}
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={1}
              sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center' }}>
              <Box sx={{ mx: 0, py: 0, my: 0 }}>
                <Button aria-label="language" color="inherit" variant="text" {...bindHover(lngPopupState)} sx={{ minWidth: '22px' }}>
                  {languageSelect(language, showLngTxt)}
                </Button>
                <HoverMenu
                  {...bindMenu(lngPopupState)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
                  {languages.map((lng, menuindex) => {
                    return (
                      <MenuItem
                        key={`${menuindex}`}
                        onClick={(event) => {
                          event.preventDefault();
                          lngPopupState.close;
                          // changeLanguage(lng);
                        }}>
                        <Link
                          to={originalPath}
                          language={lng}
                          id="languageSelect"
                          className="languageSelect"
                          style={{ textDecoration: 'none' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              alignContent: 'center',
                              justifyContent: 'flex-start',
                            }}>
                            {languageSelect(lng, true)}
                          </Box>
                        </Link>
                      </MenuItem>
                    );
                  })}
                </HoverMenu>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      {/*main content*/}
      <Box className="main-content">
        <Box className="center" sx={{ minHeight: 'calc(100vh - (0px + 64px + 34px + 128px))', mt: 'calc(34px + 64px)' }}>
          {children}
        </Box>
        <Box className="footer" sx={{ width: '100vw', minHeight: '162px' }}>
          <LazyLoader priority={LazyLoader.Priority.LOW}>
            <Footer />
          </LazyLoader>
        </Box>
      </Box>

      {/*mobile menu*/}
      <Drawer anchor="left" open={menuOpen} onOpen={() => {}} onClose={() => setMenuOpen(false)}>
        <Paper elevation={0} sx={{ width: 200, maxWidth: '100%', bgcolor: 'rgb(255, 255, 255, 0.8)' }}>
          <MenuList>
            <MenuItem>
              <ListItemIcon sx={{ minWidth: '16px' }}>
                <WatchLaterOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                <Link to={'/all-mens-watches'} language={language} id="navMenu" className="navMenu" style={{ textDecoration: 'none' }}>
                  <Trans>Men's Watch</Trans>
                </Link>
              </ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem>
              <ListItemIcon sx={{ minWidth: '16px' }}>
                <WatchLaterOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                <Link to={'/all-womens-watches'} language={language} id="navMenu" className="navMenu" style={{ textDecoration: 'none' }}>
                  <Trans>Women's Watch</Trans>
                </Link>
              </ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem>
              <ListItemIcon sx={{ minWidth: '16px' }}>
                <WatchLaterOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>
                <Link to={'/all-straps'} language={language} id="navMenu" className="navMenu" style={{ textDecoration: 'none' }}>
                  <Trans>Watch Straps</Trans>
                </Link>
              </ListItemText>
            </MenuItem>
          </MenuList>
        </Paper>
      </Drawer>

      {/*Cart*/}
      <Drawer anchor="right" open={open} onOpen={() => {}} onClose={() => setOpen(false)}>
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            width: '100%',
            maxWidth: { xs: '100%', md: '600px' },
            bgcolor: '#00000001',
            py: 1,
            pl: 1,
            pr: 1,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              alignContent: 'center',
              justifyContent: 'flex-start',
              alignItems: 'center',
              borderRadius: '4px',
              bgcolor: '#00000009',
              p: '2px',
              width: '100%',
            }}>
            <IconButton
              aria-label="cart"
              sx={{
                m: 0,
                py: 0,
                pl: 0,
                pr: '0.5rem',
                '&:hover': {
                  bgcolor: '#00000009',
                },
              }}
              onClick={() => {
                setOpen(false);
              }}>
              <ChevronRightOutlinedIcon fontSize="medium" />
            </IconButton>
            <Typography variant="caption" component="h2" sx={{ color: '#00000088' }}>
              <Trans>30 Days Returns and 1 Year Warranty</Trans>
            </Typography>
          </Box>
          {stripeLoaded ? (
            <Elements
              // stripe={loadStripe(
              //   // process.env.STRIPE_PUBLISHABLE_KEY
              //   'pk_live_51GtwKiJYwiQvGDcVOTV7PpDTezJh1WQYbdpLmKooduIRi6E3nKac4Tx8BLTqhnNKJK5kvdFbLkWpTOjZIMl1HEGX00unyIPaUI'
              // 'pk_test_51GtwKiJYwiQvGDcVtSKJppLk5STcN4xPsrB0jFlCD3zbDXpNb5jhj5yJPqDv6jPyVVHpFX0a2nDVmmTkH4ByXA4d00Xz6gKy5N'
              // )}>
              stripe={stripeObject}>
              <Cart />
            </Elements>
          ) : null}
        </Box>
      </Drawer>
    </Box>
  );
};

const ConnectedLayout: React.FunctionComponent<PageLayoutProps> = (props) => {
  return (
    <ShopifyProvider>
      {/*<LayoutProvider>*/}
      <PageLayout {...props} />
      {/*</LayoutProvider>*/}
    </ShopifyProvider>
  );
};

export default ConnectedLayout;
